export enum Language {
    ru = 'ru',
    en = 'en'
}
